import { createPermission } from '@backstage/plugin-permission-common';

export const keycloakAdminPermission = createPermission({
  name: 'platform.keycloak.admin',
  attributes: { action: 'update' },
});
